<script setup>
import {onMounted, watch} from "vue";
import GlobalLayout from "@/Layouts/GlobalLayout.vue";

let props = defineProps({
    content: String,
    title: String,
});

onMounted(() => {
    document.body.classList.add('preview-page');
});
</script>
<template>
    <GlobalLayout>
    <div class="bg-black">
        <div class="wrapper p-5">
            <h1 class="text-center mb-4">
                <strong>{{ title && title !== '' ? title : 'File' }}</strong>
            </h1>
            <hr>
            <div class="p-5">
                <div class="highlight-mode fr-element" v-html="content"></div>
            </div>
        </div>
    </div>
    </GlobalLayout>
</template>
<style lang="scss">
@import "resources/css/v4/layouts/styles/filePreview.scss";
</style>
